import { Card, Col, Container } from "react-bootstrap";
import SubTitle from "./SubTitle";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Fade } from "react-awesome-reveal";
import { emptyVendorProducts } from "../../redux/actions/vendorActions";

export default function VendorsCard({title,btntitle,hasSlice=false,customClasses}) {
 
  const navigate = useNavigate();
   const dispatch = useDispatch();



  const vendors = useSelector((state) => state.usersReducers.allVendors);

  console.log("vendors", vendors);

  const allproduct = useSelector(
      (state) => state.vendorReducer.getProductsByVendorId
    );

    console.log('vendor products',allproduct);

    let vendorsToShow=[];

    if(hasSlice==true) vendorsToShow=vendors?.slice(0, 6);
    else vendorsToShow=vendors;
    
  

  return (
    <Container className="my-3">
      <SubTitle title={title} btntitle={btntitle} path="/allVendors" state={vendors} />
      <Col
        className={`d-flex w-100  my-3 vendorContainer ${customClasses}`}
        
      >
        {vendors?.length > 0 &&
          vendorsToShow?.map((vendor, index) => (
            <Card
              key={index}
              className="my-1 vendorCard"
              style={{
                borderRadius: "12px",
                border: "none",
                backgroundColor: "#FFFFFF",
                justifyContent: "center",
                cursor: "pointer"
              }}

               onClick={() => {
                   // console.log("e.target.id", e.target.id);
                    // let vendorOBJ=vendors?.find(vendor=>vendor._id==e.target.id);
                    let vendorOBJ = vendors?.find(v => v?._id === vendor?._id);
                    console.log("vendorOBJ",vendorOBJ);
                    dispatch(emptyVendorProducts());
                    navigate(`/${vendorOBJ?.username}?page=1`);
                    // navigate(`/category/subcategory/${id}`);
                  }}
              //  id={vendor._id}

            >
              <Fade>
                <Card.Img
                 
                  style={{
                    height: "60px",
                    width: "95%",
                    objectFit: "contain",
                    cursor: "pointer",
                    alignSelf: "center",
                  }}
                  // id={vendor._id}
                  src={vendor?.image}
                  loading="lazy"
                />
                <p
                  className="categoty-card-text my-1"
                  style={{
                    padding: "5px",
                    whiteSpace: "nowrap", // keeps text on one line

                    // width:'fit-content',
                  }}
                >
                  {vendor?.username}
                </p>
              </Fade>
            </Card>
          ))}
      </Col>
    </Container>
  );
}
